import { Routes } from '@angular/router';
import { AuthComponent } from '../features/auth/pages/auth.component';
import { ParentLayoutComponent } from '../layouts/parent/parent-layout.component';
import { RoleGuard } from '../core/guards/role.guard';
import { HomeComponent } from '../features/home/pages/home.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { ERole } from '../features/auth/enums/role.enum';
import { ProfileComponent } from '../features/user/pages/profile/profile.component';
import { ParentAiAssistantComponent } from '../features/parent-ai-assistant/parent-ai-assistant.component';
import { HomeAssignmentsViewComponent } from '../features/home/pages/home-assignments-view.component';
import { HomeWelcomeComponent } from '../features/home/pages/home-welcome/home-welcome.component';
import { CoursesGridComponent } from '../features/home/components/courses-grid/courses-grid.component';
import { ParentCourseLearnComponent } from '../features/parent-learning/pages/parent-course-learn/parent-course-learn.component';
import { ForgotPasswordRequestComponent } from '../features/auth/pages/forgot-password-request/forgot-password-request.component';
import { UpdatePasswordComponent } from '../features/auth/pages/update-password/update-password.component';
import { ParentLinkApprovalComponent } from '../features/user/pages/parent-link-approval/parent-link-approval.component';
import { FamilyHubComponent } from '../features/parent-family/pages/family-hub/family-hub.component';
import { CoParentInviteAcceptComponent } from '../features/parent-family/pages/co-parent-invite-accept/co-parent-invite-accept.component';
import { ParentPatrolDashboardComponent } from '../features/parent-patrol/pages/parent-patrol-dashboard/parent-patrol-dashboard.component';
import { parentPatrolEnabledGuard } from '../features/parent-patrol/guards/parent-patrol-enabled.guard';
import { ParentIdentityVerifyComponent } from '../features/identity/pages/parent-identity-verify/parent-identity-verify.component';
import { ParentIdentityHubComponent } from '../features/identity/pages/parent-identity-hub/parent-identity-hub.component';
import { ParentDisclosureApprovalsComponent } from '../features/identity/pages/parent-disclosure-approvals/parent-disclosure-approvals.component';
import { ParentDisclosureGrantsComponent } from '../features/identity/pages/parent-disclosure-grants/parent-disclosure-grants.component';
import {
  layoutRoleChildGuard,
  layoutRoleGuard,
} from '../core/guards/layout-role.guard';

export function getParentRoutes(): Routes {
  return [
    {
      path: 'parent-link-approval/:token',
      component: ParentLinkApprovalComponent,
    },
    {
      path: 'co-parent-invite',
      component: CoParentInviteAcceptComponent,
    },
    {
      path: 'co-parent-invite/:token',
      component: CoParentInviteAcceptComponent,
    },
    {
      path: '',
      component: ParentLayoutComponent,
      data: { layout: 'parent', layoutRoles: [ERole.PARENT] },
      canActivate: [layoutRoleGuard],
      canActivateChild: [layoutRoleChildGuard],
      children: [
        {
          path: '',
          pathMatch: 'full',
          redirectTo: 'auth',
        },
        {
          path: 'auth',
          component: AuthComponent,
        },
        {
          path: 'auth/forgot-password',
          component: ForgotPasswordRequestComponent,
        },
        {
          path: 'auth/update-password',
          component: UpdatePasswordComponent,
        },
        {
          path: 'home',
          canActivate: [AuthGuard, RoleGuard],
          component: HomeComponent,
          data: { roles: [ERole.PARENT] },
          children: [
            {
              path: '',
              pathMatch: 'full',
              redirectTo: 'welcome',
            },
            {
              path: 'welcome',
              component: HomeWelcomeComponent,
            },
            {
              path: 'assignments',
              component: HomeAssignmentsViewComponent,
            },
            {
              path: 'courses',
              component: CoursesGridComponent,
            },
            {
              path: 'courses/:id',
              component: ParentCourseLearnComponent,
            },
          ],
        },
        {
          path: 'family',
          canActivate: [AuthGuard, RoleGuard],
          component: FamilyHubComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: 'profile',
          canActivate: [AuthGuard, RoleGuard],
          component: ProfileComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: 'identity',
          canActivate: [AuthGuard, RoleGuard],
          component: ParentIdentityHubComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: 'identity/verify',
          canActivate: [AuthGuard, RoleGuard],
          component: ParentIdentityVerifyComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: 'identity/disclosure-approvals',
          canActivate: [AuthGuard, RoleGuard],
          component: ParentDisclosureApprovalsComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: 'identity/pending-approvals',
          canActivate: [AuthGuard, RoleGuard],
          component: ParentDisclosureApprovalsComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: 'identity/disclosure-grants',
          pathMatch: 'full',
          redirectTo: '/identity/connected-apps',
        },
        {
          path: 'identity/connected-apps',
          canActivate: [AuthGuard, RoleGuard],
          component: ParentDisclosureGrantsComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: 'patrol',
          canActivate: [AuthGuard, RoleGuard, parentPatrolEnabledGuard],
          component: ParentPatrolDashboardComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: 'ai-assistant',
          canActivate: [AuthGuard, RoleGuard],
          component: ParentAiAssistantComponent,
          data: { roles: [ERole.PARENT] },
        },
        {
          path: '**',
          redirectTo: 'home',
        },
      ],
    },
  ];
}
